import { ACTIONS, initialState, reducer } from "./loginReducer";
import { useReducer } from "react";
import Button from "../../components/ui/buttons/Button";
import Copyright from "../../components/ui/labels/Copyright";
import DevModeLabel from "../../components/ui/labels/DevModeLabel";
import FullScreenActivityIndicator from "../../components/ui/activityIndicator/FullScreenActivityIndicator";
import Logo from "../../components/ui/labels/Logo";
import packageJson from "../../../package.json";
import passwordSVG from "../../assets/lock.svg";
import ProjectLabel from "../../components/ui/labels/ProjectLabel";
import StatusPrompt from "../../components/ui/prompts/StatusPrompt";
import styles from "./Login.module.css";
import TextInput from "../../components/ui/input/TextInput";
import useLogin from "./useLogin";
import userSVG from "../../assets/user.svg";

const Login = () => {
  // State.
  const [state, dispatch] = useReducer(reducer, initialState);

  // Business logic.
  const {
    loginFormHandler,
    passwordChangedHandler,
    statusClearedHandler,
    usernameChangedHandler,
  } = useLogin({ state: state, dispatch: dispatch, ACTIONS: ACTIONS });

  // JSX.
  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginDiv}>
        <Logo />
        <ProjectLabel />
        <Copyright />
        <form onSubmit={loginFormHandler} className={styles.formInput}>
          <TextInput
            label="Username"
            img={userSVG}
            onChange={usernameChangedHandler}
            value={state.username}
            type="text"
            autocomplete="username"
          />
          <TextInput
            label="Password"
            img={passwordSVG}
            onChange={passwordChangedHandler}
            value={state.password}
            autocomplete="current-password"
            type="password"
          />
          <Button text="Login" disabled={!state.formValid} />
        </form>
        <DevModeLabel />
        <p className={styles.version}>{`v${packageJson.version}`}</p>
      </div>
      {state.status && (
        <StatusPrompt
          isActive={true}
          text={state.status}
          statusCleared={statusClearedHandler}
        />
      )}
      <FullScreenActivityIndicator
        loading={state.loading}
        text="Authenticating..."
      />
    </div>
  );
};

export default Login;
